import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './usuarioForm';

import { setModoTela, initForm, salvar, excluir, getLista, setPermissao, getListaParceiro } from './usuarioActions';

class Usuario extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaParceiro();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let acessoUsuario = this.props.usuarioLogado && this.props.usuarioLogado.acesso_usuario;

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								disabled={!acessoUsuario}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({  usuario: true, ponto_atendimento: false, vendedor: false });
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1}>Nome</Th>
								<Th colspan={1}>Login</Th>
								<Th width={100} alignCenter>Usuários</Th>
								<Th width={100} alignCenter>Cadastros</Th>
								<Th width={100} alignCenter>Financeiro</Th>
								<Th width={100} alignCenter>Resumido</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome}</Td>
									<Td>{item.login}</Td>
									<Td alignCenter>
										<button type='button'
											disabled={!acessoUsuario}
											title='Acesso aos dados dos usuários'
											class={`btn btn-${item.acesso_usuario ? 'success' : 'default'} btn-sm`}
											onClick={() => this.props.setPermissao({ ...item, acesso_usuario: !item.acesso_usuario })}><i class={`far fa${item.acesso_usuario ? '-check' : ''}-square`}></i>
										</button>
									</Td>
									<Td alignCenter>
										<button type='button'
											disabled={!acessoUsuario}
											title='Acesso ao financeiro'
											class={`btn btn-${item.acesso_cadastro ? 'success' : 'default'} btn-sm`}
											onClick={() => this.props.setPermissao({ ...item, acesso_cadastro: !item.acesso_cadastro })}><i class={`far fa${item.acesso_cadastro ? '-check' : ''}-square`}></i>
										</button>
									</Td>
									<Td alignCenter>
										<button type='button'
											disabled={!acessoUsuario}
											title='Acesso ao financeiro'
											class={`btn btn-${item.acesso_financeiro ? 'success' : 'default'} btn-sm`}
											onClick={() => this.props.setPermissao({ ...item, acesso_financeiro: !item.acesso_financeiro })}><i class={`far fa${item.acesso_financeiro ? '-check' : ''}-square`}></i>
										</button>
									</Td>
									<Td alignCenter>
										<button type='button'
											disabled={!acessoUsuario}
											title='Acesso resumido'
											class={`btn btn-${item.acesso_resumido ? 'success' : 'default'} btn-sm`}
											onClick={() => this.props.setPermissao({ ...item, acesso_resumido: !item.acesso_resumido })}><i class={`far fa${item.acesso_resumido ? '-check' : ''}-square`}></i>
										</button>
									</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											disabled={!acessoUsuario}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											disabled={!acessoUsuario}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	modoTela: state.usuario.modoTela,
	lista: state.usuario.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, setPermissao, getListaParceiro }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Usuario);
